import React from "react";
import Image from "next/image";
import { useDeviceType } from "@/hooks/useDeviceType";
import { renderRichText } from "@/utils/formatters";

const ToolCard = ({ cardData = {} }) => {
  const {
    image,
    richDescription,
    showReverse = false,
    subTitle,
    subTitleColor = "Black",
    title,
    titleFontSize,
    description,
  } = cardData;

  const description2 = renderRichText(richDescription);
  const richSubTitle = renderRichText(subTitle);
  const Buttonprops = {
    children: "Button",
    variant: "primary",
    size: "small",
    fullWidth: false,
    disabled: false,
  };
  const { isBelow, isAbove } = useDeviceType(767);

  const imageBoxClass = isBelow
    ? "w-full h-auto"
    : "w-[450px] min-w-[450px] h-[354px] shrink-0";
  const buttonClick = () => {
    window.open(buttonLink, "_blank");
  };
  return (
    <div className={`row koh-top-row flex flex-row w-full `}>
      <div
        id={cardData?.id}
        className="card-section flex  flex-col gap-0 md:gap-6 w-full"
      >
        <hr className="border-gray-300 flex-grow line" />

        <div
          className={`${showReverse ? "md:flex-row-reverse" : "md:flex-row"} flex-col flex w-full gap-[60px] mb-10 mt-5`}
        >
          <div
            className={`image-wrapper relative flex flex-col gap-5 ${imageBoxClass}`}
          >
            <Image
              src={image?.fields?.imageUrl}
              alt={image?.fields?.alt || image?.fields?.altText}
              width={450}
              height={354}
              className={isBelow ? "!w-full !h-auto" : "!w-[450px] !h-[354px]"}
            />
          </div>
          <div className="article-button-section flex flex-col w-full">
            {title && (
              <p
                className={`articleHeading mb-[10px] text-[${titleFontSize}px] leading-none font-[Helvetica-Light,_Helvetica,_sans-serif] text-[#232323]`}
              >
                {title}
              </p>
            )}
            {richSubTitle && (
              <div
                className={`${subTitleColor ? "text-[#84888b]" : "text-[#232323]"} !font-[HelveticaRoman,_Helvetica,_sans-serif]`}
              >
                {richSubTitle}
              </div>
            )}
            {description ? (
              <div className="koh-pro-toolbox-text-body">
                <p className="font-normal break-words">{description}</p>
              </div>
            ) : description2 ? (
              <div>
                <div className="font-[HelveticaRoman,_Helvetica,_sans-serif] leading-[1.5]">
                  {description2}
                </div>
              </div>
            ) : null}
            {/* <div className=" flex w-full">
              <button
                onClick={buttonClick}
                class="px-4 py-2 text-md md:text-lg bg-black w-[140px] button text-white font-semibold text-base rounded hover:bg-gray-400 hover:text-white transition"
              >
                {buttonLabel}
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToolCard;
